import { Button, Typography } from '@mui/material';
import './End.scss';

import { CheckCircle } from '@mui/icons-material';
import { FC } from "react";
import { useNavigate, useParams } from 'react-router-dom';

const End: FC = () => {
	const {id} = useParams<{ id: string }>();
	const navigate = useNavigate();

	const handleLogout = () => {
		localStorage.clear();
		navigate(`/${id}/login`);
	}

	return (
		<div className="end">
			<div className="end-data">
				<Typography variant='h5' align='justify'>
					Questionário finalizado!
				</Typography>
				<Typography variant='h6' align='justify'>
					Muito obrigado por sua participação.
				</Typography>
				<CheckCircle color='success' sx={{fontSize: "60px"}}/>
			</div>
			<Button
				variant="contained"
				href={`/${id}/login`}
				onClick={handleLogout}
				color="primary"
				disableElevation
				size="large"
				sx={{ width: "200px", marginTop: "20px" }}
			>
				Iniciar nova resposta
			</Button>
		</div>
	)
}

export default End;